/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { withTheme } from '@emotion/react';
import { Grid, Toolbar, Typography } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import NavbarUserDropdown from './navbar-user-dropdown';
import { AppBar, IconButton, SmallAvatar } from './style';
//
const Navbar = ({ onDrawerToggle }) => (
  <AppBar
    position="sticky"
    elevation={0}
    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, height: 64 }}
  >
    <Toolbar>
      <Grid container alignItems="center" justifyContent="space-between" direction="row">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid item sx={{ display: { xs: 'block', md: 'none' } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid
              item
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <SmallAvatar variant="square" src="/static/assets/logo-light.png" />
            </Grid>
            <Grid item>
              <Typography
                variant="h3"
                sx={{
                  color: '#e5e5e5',
                }}
              >
                Admin Portal
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <NavbarUserDropdown />
        </Grid>
      </Grid>
    </Toolbar>
  </AppBar>
);
//
export default withTheme(Navbar);
